import React, {useContext,useEffect,useState} from 'react'
import {Card, CardHeader, CardActions, CardContent,Typography, Button, Alert, Box,Grid,CardMedia} from '@mui/material'
import { formularioContext } from '../contextos/FormularioContext'
import {useParams} from 'react-router-dom'
import {ETPrecios} from './ETPrecios'
import Axios from 'axios'
import { PreguntasFrecuentes } from './PreguntasFrecuentes'
import { useNavigate } from 'react-router-dom';
import { ETInscripcion } from './ETInscripcion'
import EventIcon from '@mui/icons-material/Event';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import {ETError} from './ETError'
import {ETLoading} from './ETLoading'

export const ETEvento = ({id})=>{
    const {updateEventoValorSeleccionado,reinicializar,cargando,error} = useContext(formularioContext)
    const [evento,setEvento]= useState(null)
    const [itemSelected,selectItem]= useState(null)
    const parametros = useParams()
    const navigate = useNavigate()

    useEffect(()=>{
           const obtenerEvento = async ()=>{
            try{
                const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/api/eventos/evento/${parametros?.id_evento}`:`https://uadapi.uad.digital/api/eventos/evento/${parametros?.id_evento}`)
               
                setEvento(data) 

            }catch(err){
                console.log('Error loading events',err)
            }
        }

        if(parametros?.id_evento){
            obtenerEvento()
        }
        
    },[parametros])

    useEffect(()=>{
        updateEventoValorSeleccionado(itemSelected)
        if(!itemSelected){
            reinicializar()
        }
    },[itemSelected])

    if(cargando){
        return <ETLoading/>
    }

    if(error?.length){
        return <div>
            <ETError/>
        </div>  
    }    
    
    if (!(evento?.id_tipo_evento==1)){ // modificación por tema elecciones 06/09/2025 hay eventos tipo publico, privado...etc el id_tipo_evento es nuevo
         return <div>
            <ETError mensaje={`El evento ${evento?.titulo} no es público`}/>
        </div>  
    }

    return  <Box sx={{ p: { xs: 2, md: 8 }, background:'blue',backgroundColor:'white',width:'100%' }}>
     <Grid container style={{background:'orange',backgroundColor:'white'}} spacing={3}>
        <Grid item xs={12} md={5} >
            <Box
                                component="img"
                                src={evento?.foto_mini}
                                alt={evento?.titulo}
                                sx={{
                                width: '100%',
                                objectFit: 'contain',
                                p:2,
                                }}
                            />
            <Box sx={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
              <Typography variant="h4" sx={{
                cursor: 'pointer',
                '&:hover': {
                fontWeight: 'bold',
                },
                }}
                >
                {evento?.titulo}
            </Typography>
            <Box sx={{m:2}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <EventIcon style={{ marginRight: '8px', color: '#1976d2' }} />
                    <Typography variant="subtitle1" style={{ lineHeight: 1.2, fontWeight: 300,textAlign:'left' }}>{evento?.descripcion}</Typography>
                </div>
                <div style={{ display: 'flex', alignItems: 'center',marginTop:'0.5rem'}}>
                    <LocationOnIcon style={{ marginRight: '8px', color: '#1976d2' }} />
                    <Typography variant="subtitle1" style={{ lineHeight: 1.2, fontWeight: 300,textAlign:'left' }}>{evento?.detalles}</Typography>
                </div>
            </Box>

            </Box>   
        </Grid>
        <Grid xs={12} md={7}>
            {!itemSelected && <ETPrecios evento={evento} id_evento={parametros?.id_evento} selectItem={selectItem} target={parametros?.target}/>}
            {itemSelected && <ETInscripcion eventoValor={itemSelected} cancelar={()=>selectItem(null)} target={parametros?.target}/>}
        </Grid>
    </Grid>
    <Box sx={{width:'100%'}}>
           {evento?.id_preguntas_frecuentes && <PreguntasFrecuentes id={evento?.id_preguntas_frecuentes}/>}
    </Box>
</Box>
}

